import React, { Fragment, useEffect } from "react";
import { Pagina } from "../template/Template";
import { AuthContext } from "../../App";
import {
    makeStyles,
    ThemeProvider,
    createMuiTheme,
} from "@material-ui/core/styles";
import { Formik } from "formik";
//import { AuthContext } from '../../App';
import {
    usuarioFindAll,
    usuarioInsert,
    usuarioUpdate,
    usuarioDelete,
} from "../../services/UsuarioService";

import DialogoCliente from "./usuario/DialogoCliente";
// import { siteFindByNotUsuId } from "../../services/SiteService";
import { controlesenhaFindAll } from "../../services/ControlesenhaService";
import { papelFindAll } from "../../services/PapelService";
//import { siteFindAll } from "../../services/SiteService";
import {
    DataGrid,
    ptBR,
    GridToolbarContainer,
    GridFilterToolbarButton,
} from "@material-ui/data-grid";
import { ButtonCancel, ButtonDelete, ButtonSave } from "../botoes/operacao";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
// import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import CloseIcon from "@material-ui/icons/Close";
// import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import GroupAddIcon from "@material-ui/icons/GroupAdd";

import { format } from "date-fns";
import {
    KeyboardDateTimePicker,
    MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { Loading } from "../Loading";
import { ShowMessageBox } from "../ShowMessageBox";
//import { PickList } from "primereact/picklist";

// import {
//   usuarioxsiteDeleteByUsuId,
//   usuarioxsiteInsert,
//   usuarioxsiteFindByUsuId,
// } from "../../services/UsuarioxsiteService";
//import {
//    usuarioxclienteDispEmUso,
//    usuarioxclienteInsert,
//} from "../../services/UsuarioxclienteService";
import { Tooltip } from "@material-ui/core";

let inserir = false;

const theme = createMuiTheme(
    //    {
    //      palette: {
    //        primary: { main: '#1976d2' },
    //      },
    //    },
    ptBR
);

const useStyles = makeStyles((theme) => ({
    box: {
        display: "flex",
        "flex-direction": "row",
        "justify-content": "center",
        marginLeft: "2rem",
        alignItems: "center",
        height: "75vh",
        width: "95vw",
        backgroundColor: "transparent",
    },
    boxPrancheta: {
        backgroundColor: "white",
        height: "75vh",
        width: "95vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
    },
    boxDataGrid: {
        "& .header_grid": {
            backgroundColor: "#2471A3",
            color: "white",
        },
        height: "75vh",
        width: "95vw",
        "& .MuiDataGrid-row.Mui-even:not(:hover)": {
            backgroundColor: "#D6EAF8",
            color: "black",
        },
        "& .MuiDataGrid-row.Mui-odd:not(:hover)": {
            backgroundColor: "#AED6F1",
            color: "black",
        },
        "& .MuiDataGrid-row.Mui-selected:not(:hover)": {
            backgroundColor: "#999999",

            color: "white",
        },

        "& .MuiDataGrid-row.Mui-selected:hover": {
            backgroundColor: "#999999",
            color: "white",
        },
        "& .MuiDataGrid-row:hover": {
            backgroundColor: "#D3D3D3",
            color: "black",
        },
    },
    side_content: {
        display: "grid",
        overflow: "auto",
    },
    nome: {
        width: "400px",
    },
    header_grid: {
        backgroundColor: "black",
        color: "white",
    },
    input_data: {
        display: "flex",
        flexDirection: "column",
    },
    fab: {
        display: "inline",
        position: "absolute",
        bottom: 0,
        left: "50%",
        transform: "translateX(-50%)",
        paddingTop: "100px",
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

let severity = "success";
let msg = "";

export default function Usuario() {
    const classes = useStyles();
    const { state: authState } = React.useContext(AuthContext);

    const [openSnackBar, setOpenSnackBar] = React.useState(false);
    const [openDialog, setOpenDialog] = React.useState(false);

    const [listUsuario, setListUsuario] = React.useState([]);

    const [selection, setSelection] = React.useState({});

    const [controlesenha, setControlesenha] = React.useState({});
    const [listPapel, setListPapel] = React.useState([]);
    //const [listSite, setListSite] = React.useState([]);
    const [openLoading, setOpenLoading] = React.useState(false);
    const [openDialogCliente, setOpenDialogCliente] =
        React.useState(false);

    const closeDialog = () => {
        inserir = false;
        setOpenDialog(false);
    };

    const closeDialogCliente = () => {
        inserir = false;
        setOpenDialogCliente(false);
    };

    const Dialogo = () => {
        const [openLoadingDialog, setOpenLoadingDialog] = React.useState(false);
        const [openSnackBarDialog, setOpenSnackBarDialog] = React.useState(false);

        const deleteRecord = async () => {
            setOpenSnackBarDialog(false);

            const usuario = { usu_email: selection.usu_email };
            try {
                setOpenLoadingDialog(true);
                await usuarioDelete(usuario);
                const respUsuario = await usuarioFindAll();
                setListUsuario(respUsuario.data);
                setOpenDialog(false);
                setOpenLoadingDialog(false);
                inserir = true;
            } catch (error) {
                msg =
                    "Erro ao excluir o usuario. Usuário esta sendo utilizado pelo sistema";
                severity = "error";
                console.log(error);
                setOpenSnackBarDialog(true);
                setOpenLoadingDialog(false);
            }
        };

        return (
            <Dialog open={openDialog} aria-labelledby="form-dialog-title">
                <div
                    id="form-dialog-title"
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        paddingRight: "2rem",
                        paddingLeft: "2rem",
                        alignItems: "center",
                        background: "lightblue",
                        height: "4rem",
                    }}
                >
                    <span style={{ fontSize: "1.2rem" }}>Manutenção de usúario</span>
                    <ButtonCancel
                        variant="contained"
                        color="primary"
                        type="button"
                        style={{
                            padding: "3px",
                            color: "white",
                            fontWeight: "bold",
                        }}
                        onClick={closeDialog}
                    >
                        <CloseIcon />
                    </ButtonCancel>
                </div>
                <DialogContent>
                    <Loading open={openLoadingDialog} />
                    <ShowMessageBox
                        open={openSnackBarDialog}
                        setOpen={setOpenSnackBarDialog}
                        severity={severity}
                        msg={msg}
                    />
                    <Formik
                        initialValues={{
                            usuEmail: selection.usu_email,
                            usuNome: selection.usu_nome,
                            usuApelido: selection.usu_apelido,
                            usuSenha1: selection.usu_senha,
                            usuSenha2: selection.usu_senha,
                            cosId: selection.cos_id,
                            papId: selection.pap_id,
                            usuBloqueado: selection.usu_bloqueado,
                            usuDataBloqueio:
                                selection.usu_data_bloqueio == null
                                    ? null
                                    : selection.usu_data_bloqueio,
                            sitId: selection.sit_id,
                            usuAlerta: selection.usu_alerta,
                        }}
                        validate={(values) => {
                            const errors = {};
                            if (!values.usuEmail) {
                                errors.usuEmail = "E-mail é Obrigatório";
                            } else if (
                                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                                    values.usuEmail
                                )
                            ) {
                                errors.usuEmail = "E-mail invalido";
                            } else if (!values.usuNome) {
                                errors.usuNome = "Obrigatório";
                            } else if (!values.usuApelido) {
                                errors.usuApelido = "Obrigatório";
                            } else if (!values.usuSenha1) {
                                errors.usuSenha1 = "Obrigatório";
                            } else if (
                                values.usuSenha1.length < controlesenha.cos_min_caracter
                            ) {
                                errors.usuSenha1 =
                                    "Minimo " + controlesenha.cos_min_caracter + " caracteres";
                            } else if (!values.usuSenha2) {
                                errors.usuSenha1 = "Obrigatório";
                            } else if (
                                values.usuSenha2.length < controlesenha.cos_min_caracter
                            ) {
                                errors.usuSenha2 =
                                    "Minimo " + controlesenha.cos_min_caracter + " caracteres";
                            } else if (values.usuSenha1 !== values.usuSenha2) {
                                errors.usuSenha1 = "Senhas diferentes";
                            } else if (controlesenha.cos_complexa) {
                                let hasUpperCase = /[A-Z]/.test(values.usuSenha1);
                                let hasLowerCase = /[a-z]/.test(values.usuSenha1);
                                let hasNumbers = /\d/.test(values.usuSenha1);
                                let hasNonalphas = /\W/.test(values.usuSenha1);
                                if (
                                    hasUpperCase + hasLowerCase + hasNumbers + hasNonalphas <
                                    3
                                ) {
                                    errors.usuSenha1 = "Senhas não complexas";
                                }
                            } else if (!values.papId) {
                                errors.papId = "Papel não selecionado";
                            }
                            return errors;
                        }}
                        onSubmit={async (values, { setSubmitting }) => {
                            setSubmitting(true);
                            setOpenLoadingDialog(true);
                            if (inserir) {
                                try {
                                    await usuarioInsert({
                                        usu_email: values.usuEmail,
                                        usu_nome: values.usuNome,
                                        usu_apelido: values.usuApelido,
                                        usu_senha: values.usuSenha1,
                                        pap_id: values.papId,
                                        usu_bloqueado:
                                            values.usuDataBloqueio === null
                                                ? false
                                                : values.usuBloqueado,
                                        usu_data_bloqueio:
                                            values.usuDataBloqueio === null
                                                ? null
                                                : format(values.usuDataBloqueio, "yyyy-mm-dd"),
                                        sit_id: values.sitId === "" ? null : values.sitId,
                                        usu_tentativas: 0,
                                        usu_alerta:
                                            values.usuAlerta === null ? false : values.usuAlerta,
                                        usu_dt_troca_senha: format(
                                            new Date(),
                                            "yyyy-MM-dd'T'HH:mm:ss"
                                        ),
                                        usu_solicita_troca: false,
                                        usu_seq_download: 0,
                                    });

                                    const respUsuario = await usuarioFindAll();
                                    setListUsuario(respUsuario.data);
                                    msg = "Usuario incluido com sucesso";
                                    severity = "success";
                                    setOpenDialog(false);
                                    setOpenLoadingDialog(false);
                                } catch (error) {
                                    msg = "Erro ao inserir usuario";
                                    severity = "error";
                                    setOpenSnackBar(true);
                                    setOpenLoadingDialog(false);
                                }
                            } else {
                                try {
                                    await usuarioUpdate({
                                        usu_email: values.usuEmail,
                                        usu_nome: values.usuNome,
                                        usu_apelido: values.usuApelido,
                                        usu_senha: values.usuSenha1,
                                        pap_id: values.papId,
                                        sit_id: values.sitId === "" ? null : values.sitId,
                                        usu_bloqueado:
                                            values.usuDataBloqueio === undefined
                                                ? false
                                                : values.usuBloqueado,
                                        usu_data_bloqueio:
                                            values.usuDataBloqueio === null
                                                ? null
                                                : values.usuDataBloqueio,
                                        usu_tentativas: 0,
                                        usu_alerta:
                                            values.usuAlerta === null ? false : values.usuAlerta,
                                        usu_solicita_troca: false,
                                    });

                                    const respUsuario = await usuarioFindAll();
                                    setListUsuario(respUsuario.data);
                                    msg = "Usuario atualizado com sucesso";
                                    severity = "success";
                                    setOpenSnackBar(true);
                                    setOpenDialog(false);
                                    setOpenLoadingDialog(false);
                                } catch (error) {
                                    msg = "Erro ao selecionar todos os usuarios";
                                    severity = "error";
                                    setOpenSnackBar(true);
                                    setOpenLoadingDialog(false);
                                }
                            }
                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            setFieldValue,
                            isValid,
                        }) => (
                            <form onSubmit={handleSubmit} className={classes.form}>
                                <div className={classes.input_data}>
                                    <TextField
                                        value={values.usuEmail}
                                        id="usuEmail"
                                        name="usuEmail"
                                        type="text"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="E-mail do Usuario"
                                        className={classes.nome}
                                        helperText={errors.usuEmail}
                                    />

                                    <TextField
                                        value={values.usuNome}
                                        name="usuNome"
                                        id="usuNome"
                                        type="text"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Nome do Usuario"
                                        className={classes.nome}
                                        helperText={errors.usuNome}
                                    />

                                    <TextField
                                        value={values.usuApelido}
                                        name="usuApelido"
                                        type="text"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Apelido"
                                        className={classes.nome}
                                        helperText={errors.usuApelido}
                                    />

                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-around",
                                        }}
                                    >
                                        <TextField
                                            value={values.usuSenha1}
                                            id="usuSenha1"
                                            name="usuSenha1"
                                            type="password"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            label="Senha1"
                                            className={classes.nome}
                                            style={{ width: "150px" }}
                                            helperText={errors.usuSenha1}
                                        />

                                        <TextField
                                            value={values.usuSenha2}
                                            id="usuSenha2"
                                            name="usuSenha2"
                                            type="password"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            label="Senha2"
                                            style={{ width: "150px" }}
                                            className={classes.nome}
                                            helperText={errors.usuSenha2}
                                        />
                                    </div>

                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={values.usuBloqueado}
                                                onChange={(e) => {
                                                    handleChange(e);
                                                    if (!values.usuBloqueado) {
                                                        setFieldValue(
                                                            "usuDataBloqueio",
                                                            format(new Date(), "yyyy-MM-dd'T'HH:mm:ss")
                                                        );
                                                    } else {
                                                        setFieldValue("usuDataBloqueio", null);
                                                    }
                                                }}
                                                name="usuBloqueado"
                                                color="primary"
                                            />
                                        }
                                        label="Bloqueado"
                                    />

                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDateTimePicker
                                            value={values.usuDataBloqueio}
                                            name="usuDataBloqueio"
                                            disabled={true}
                                            format="dd/MM/yyyy-HH:mm:ss"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={classes.nome}
                                            helperText={errors.usuDataBloqueio}
                                        />
                                    </MuiPickersUtilsProvider>

                                    <FormControl className={classes.formControl}>
                                        <InputLabel id="label-papel">Papel</InputLabel>
                                        <Select
                                            labelId="label-papel"
                                            id="papId"
                                            name="papId"
                                            value={values.papId}
                                            onChange={handleChange}
                                        >
                                            {listPapel.map((option) => (
                                                <MenuItem key={option.pap_id} value={option.pap_id}>
                                                    {option.pap_id}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={values.usuAlerta}
                                                onChange={handleChange}
                                                name="usuAlerta"
                                                color="primary"
                                            />
                                        }
                                        label="Recebe Alertas"
                                    />

                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "flex-end",
                                        }}
                                    >
                                        <ButtonSave
                                            variant="contained"
                                            size="small"
                                            color="primary"
                                            type="submit"
                                            style={{
                                                padding: "5px",
                                                color: "white",
                                                fontWeight: "bold",
                                                height: "2rem",
                                                width: "5rem",
                                            }}
                                            disabled={!isValid}
                                        >
                                            Gravar
                                        </ButtonSave>
                                        <ButtonDelete
                                            variant="contained"
                                            color="primary"
                                            type="button"
                                            style={{
                                                padding: "5px",
                                                color: "white",
                                                fontWeight: "bold",
                                                height: "2rem",
                                                width: "5rem",
                                            }}
                                            onClick={deleteRecord}
                                            disabled={inserir}
                                        >
                                            Excluir
                                        </ButtonDelete>
                                    </div>
                                </div>
                            </form>
                        )}
                    </Formik>
                </DialogContent>
            </Dialog>
        );
    };

    useEffect(async () => {
        setOpenLoading(true);
        const respUsuario = await usuarioFindAll();
        const respPapel = await papelFindAll();
        const respControleSenha = await controlesenhaFindAll();
        //const respSite = await siteFindAll();

        setListPapel(respPapel.data);
        setListUsuario(respUsuario.data);

        //setListSite(respSite.data);
        setControlesenha(respControleSenha.data[0]);
        setOpenLoading(false);
    }, []);

    //console.log(listSite);

    const Content = () => {
        const [selectionItem, setSelectionItem] = React.useState({});
        const [selected, setSelected] = React.useState(false);

        const CustomToolbar = () => {
            return (
                <GridToolbarContainer>
                    <GridFilterToolbarButton />
                </GridToolbarContainer>
            );
        };
        const newRecord = () => {
            inserir = true;
            setSelection({
                usu_email: null,
                usu_nome: null,
                usu_apelido: null,
                usu_senha1: null,
                usu_senha2: null,
                pap_id: "Operador",
                sit_id: null,
                usu_bloqueado: false,
                usu_data_bloqueio: null,
                usu_alerta: false,
            });
            setSelected(false);
            setOpenSnackBar(false);
            setOpenDialog(true);
        };

        const editRecord = () => {
            inserir = false;
            setSelection(selectionItem);
            setSelected(false);
            setOpenSnackBar(false);
            setOpenDialog(true);
        };

        const assignUserToCliente = () => {
            inserir = false;
            setSelected(false);
            setSelection(selectionItem);
            setOpenSnackBar(false);
            setOpenDialogCliente(true);
        };

        console.log('-->openDialogCliente', openDialogCliente)
        return (
            <Fragment>
                <ShowMessageBox
                    open={openSnackBar}
                    setOpen={setOpenSnackBar}
                    severity={severity}
                    msg={msg}
                />
                <Loading open={openLoading} />
                <Dialogo />
                {openDialogCliente && <DialogoCliente isOpened={openDialogCliente} closeDialog={closeDialogCliente} usuario={selection} />}

                <div className={classes.box}>
                    <Paper className={classes.boxPrancheta} elevation={20}>
                        <div className={classes.boxDataGrid}>
                            <ThemeProvider theme={theme}>
                                <DataGrid
                                    rows={listUsuario}
                                    disableColumnMenu
                                    disableColumnReorder
                                    id="usu_id"
                                    rowHeight={50}
                                    pageSize={15}
                                    onRowSelected={(newSelection) => {
                                        setSelectionItem(newSelection.data);
                                        setSelected(true);
                                    }}
                                    components={{
                                        Toolbar: CustomToolbar,
                                    }}
                                    columns={[
                                        {
                                            field: "usu_email",
                                            headerName: "E-Mail",
                                            headerClassName: "header_grid",
                                            type: "string",
                                            headerAlign: "center",
                                            flex: 1,
                                            sortable: false,
                                        },
                                        {
                                            field: "usu_nome",
                                            headerName: "Nome",
                                            headerClassName: "header_grid",
                                            type: "string",
                                            headerAlign: "center",
                                            width: 250,
                                        },
                                        {
                                            field: "usu_apelido",
                                            headerName: "Apelido",
                                            headerClassName: "header_grid",
                                            type: "string",
                                            headerAlign: "center",
                                            width: 225,
                                        },
                                        {
                                            field: "pap_id",
                                            headerName: "Papel",
                                            headerClassName: "header_grid",
                                            type: "string",
                                            headerAlign: "center",
                                            width: 150,
                                            sortable: false,
                                        },
                                        {
                                            field: "sit_id",
                                            headerName: "Site",
                                            headerClassName: "header_grid",
                                            type: "string",
                                            headerAlign: "center",
                                            width: 130,
                                            sortable: false,
                                        },
                                        {
                                            field: "usu_bloqueado",
                                            headerName: "Bloqueado",
                                            headerClassName: "header_grid",
                                            type: "boolean",
                                            headerAlign: "center",
                                            width: 125,
                                            sortable: false,
                                        },
                                        {
                                            field: "usu_data_bloqueio",
                                            headerName: "Data Bloqueio",
                                            headerClassName: "header_grid",
                                            type: "date",
                                            headerAlign: "center",
                                            width: 140,
                                            sortable: false,
                                            valueFormatter: (params) => {
                                                if (!(params.value == null)) {
                                                    return format(
                                                        new Date(params.value),
                                                        "dd/MM/yy-HH:mm"
                                                    );
                                                }
                                                return undefined;
                                            },
                                        },
                                        {
                                            field: "usu_alerta",
                                            headerName: "Alertas",
                                            headerClassName: "header_grid",
                                            type: "boolean",
                                            headerAlign: "center",
                                            width: 125,
                                            sortable: false,
                                        },
                                    ]}
                                />
                            </ThemeProvider>
                        </div>
                        <div className={classes.fab}>
                            <Tooltip title="Novo Usuário">
                                <Fab
                                    color="primary"
                                    aria-label="add"
                                    variant="extended"
                                    onClick={newRecord}
                                    style={{ margin: "2px", height: "40px" }}
                                >
                                    <AddIcon />
                                </Fab>
                            </Tooltip>
                            <Tooltip title="Editar">
                                <Fab
                                    color="primary"
                                    aria-label="edit"
                                    variant="extended"
                                    disabled={!selected}
                                    onClick={editRecord}
                                    style={{ margin: "5px", height: "40px" }}
                                >
                                    <EditIcon />
                                </Fab>
                            </Tooltip>
                            <Tooltip title="Seleção de Cliente">
                                <Fab
                                    color="primary"
                                    aria-label="adduser"
                                    variant="extended"
                                    disabled={!selected}
                                    onClick={assignUserToCliente}
                                    style={{ margin: "5px", height: "40px" }}
                                >
                                    <GroupAddIcon />
                                </Fab>
                            </Tooltip>
                        </div>
                    </Paper>
                </div>
            </Fragment>
        );
    };
    return (
        <Fragment>
            <Pagina
                authState={authState}
                Content={Content}
                HeaderDesc="MANUTENÇÃO USUÁRIOS"
            />
        </Fragment>
    );
}
